import React from "react";
import style from "./PerUnitOptions.module.css";
import TradeIn from "./TradeIn";
import { FormCheck, FormControl, Table } from "react-bootstrap";
import AddressSelect from "./AddressSelect";
import {
  setQuoteItemCostCenter,
  setQuoteItemDeliveryAddress,
  setQuoteItemInstallationAddress,
  setQuoteItemIsRegional,
  setQuoteItemIsTheSameAddress,
  setQuoteItemIsTheSameCostCenter,
  setQuoteItemIsTheSamePurchaseOrder,
  setQuoteItemPurchaseOrder
} from "../redux/actions";
import { connect } from "react-redux";
import CheckboxRegional from "./CheckboxRegional";
import {IS_NZ} from "../constants"

function PerUnitOptions({
  item,
  setQuoteItemCostCenter,
  setQuoteItemDeliveryAddress,
  setQuoteItemInstallationAddress,
  setQuoteItemIsRegional,
  setQuoteItemIsTheSameAddress,
  setQuoteItemIsTheSameCostCenter,
  setQuoteItemIsTheSamePurchaseOrder,
  setQuoteItemPurchaseOrder
}) {
  return (
    <div className={style.root}>
      <Table variant="sm" className={style.table}>
        <thead>
          <tr>
            <th colSpan={2}>
              <FormCheck
                type="checkbox"
                onChange={e =>
                  setQuoteItemIsTheSameAddress(item, e.target.checked)
                }
                checked={item.isTheSameAddress}
                label="Same Delivery and Installation Address"
                id={`isTheSameAddress-${item.key}`}
              />
            </th>
            <th className={style.regional} />
            <th className={style.purchaseOrder}>
              <FormCheck
                type="checkbox"
                onChange={e =>
                  setQuoteItemIsTheSamePurchaseOrder(item, e.target.checked)
                }
                checked={item.isTheSamePurchaseOrder}
                label="Same PO Number"
                id={`isTheSamePurchaseOrder-${item.key}`}
              />
            </th>
            <th className={style.costCenter}>
              <FormCheck
                type="checkbox"
                onChange={e =>
                  setQuoteItemIsTheSameCostCenter(item, e.target.checked)
                }
                checked={item.isTheSameCostCenter}
                label="Same Cost Center"
                id={`isTheSameCostCenter-${item.key}`}
              />
            </th>
            <th colSpan={3} className={style.tradeIn}>
              Trade-Ins
            </th>
            <th className={style.action} />
          </tr>
          <tr>
            <th>Delivery Address</th>
            <th>Installation Address</th>
            <th>{IS_NZ ? "": "Regional"}</th>
            <th>PO Number</th>
            <th>Cost Center</th>
            <th>Brand</th>
            <th>Model</th>
            <th>Serial Number</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {Array(item.qty)
            .fill(null)
            .map((_, index) => (
              <tr key={index + 1}>
                <td>
                  <AddressSelect
                    isVisible={!item.isTheSameAddress || index === 0}
                    addressId={item.deliveryAddressId[index]}
                    onAddressIdChange={addressId =>
                      setQuoteItemDeliveryAddress(item, index, addressId)
                    }
                  />
                </td>
                <td>
                  <AddressSelect
                    isVisible={!item.isTheSameAddress}
                    addressId={item.installationAddressId[index]}
                    onAddressIdChange={addressId =>
                      setQuoteItemInstallationAddress(item, index, addressId)
                    }
                  />
                </td>
                <td className={style.regionalCell}>
                  { IS_NZ ? null
                  : <CheckboxRegional 
                    isVisible={!item.isTheSameAddress || index === 0} 
                    isRegional={item.isRegional[index]} 
                    onChange={isRegional => {setQuoteItemIsRegional(item, index, isRegional);}}/>
                  }
                </td>
                <td>
                  <FormControl
                    className={
                      item.isTheSamePurchaseOrder && index !== 0
                        ? "invisible"
                        : ""
                    }
                    type="text"
                    value={item.purchaseOrders[index]}
                    onKeyPress={e => /[^A-Za-z0-9]/.test(e.key) && e.preventDefault()}
                    onChange={e => {
                      setQuoteItemPurchaseOrder(item, index, e.target.value);
                    }}
                  />
                </td>
                <td>
                  <FormControl
                    className={
                      item.isTheSameCostCenter && index !== 0 ? "invisible" : ""
                    }
                    type="text"
                    value={item.costCenters[index]}
                    onKeyPress={e =>
                      /[^0-9a-zA-Z-]/.test(e.key) && e.preventDefault()
                    }
                    onChange={e =>
                      setQuoteItemCostCenter(item, index, e.target.value)
                    }
                  />
                </td>
                <td colSpan="4" className={style.tradeInCell}>
                  <TradeIn
                    item={item}
                    tradeInGroup={item.tradeIns[index]}
                    tradeInGroupIndex={index}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
}

export default connect(null, {
  setQuoteItemCostCenter,
  setQuoteItemDeliveryAddress,
  setQuoteItemInstallationAddress,
  setQuoteItemIsRegional,
  setQuoteItemIsTheSameAddress,
  setQuoteItemIsTheSameCostCenter,
  setQuoteItemIsTheSamePurchaseOrder,
  setQuoteItemPurchaseOrder
})(PerUnitOptions);
